// extracted by mini-css-extract-plugin
export default {"box":"styles_box__UQ238","spinner":"styles_spinner__K5Inb","iconSpin":"styles_iconSpin__OL4K-","icon-spin":"styles_icon-spin__M9LPD"};